
export class CoopPlanNumRequestModel {
  // 算出区分
  public calculationDiv: string = <string>'';

  // 媒体区分
  public mediumType: string = <string>'';

  // 部門コード
  public classCode: string = <string>'';

  // 大分類コード
  public largeClassCode: string = <string>'';

  // 中分類コード
  public middleClassCode: string = <string>'';

  // 計画数（総数）
  public planNumTotal: string = <string>'';

  // 計画ＰＩ値
  public planPI: string = <string>'';

  // 会員生協リスト
  public coopInfoList: any = new Array<any>();
}
